import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import {
  inset,
  mediaQuery,
  pxToRem,
  responsiveFontSize,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { DESKTOP_FILTER_HEIGHT_CSS_VAR } from '../constants/cssVariables';

const { spacing, text, colors } = theme;

export const filterListWrapper = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      height: 100vh;
      height: var(${DESKTOP_FILTER_HEIGHT_CSS_VAR});
      overflow-x: hidden;
      overflow-y: auto;
      ${/* Stop z-indexed items inside this wrapper overlapping the scrollbar in Chrome on MacOS */ ''}
      transform: translateZ(0);
    `,
  )};
`;

export const list = css`
  margin: 0;
  padding: ${inset(spacing.md, 40)};

  list-style: none;

  h3 {
    ${responsiveFontSize(text.sm)};
    text-transform: capitalize;
    margin-top: 0;
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0;
    `,
  )};
`;

export const listItem = css`
  padding: ${inset(0, spacing.base * 10)};
  border-bottom: solid 2px ${colors.greyGeyser};

  &:first-child {
    padding: ${stack(spacing.base * 10)};
  }

  &:last-child {
    border: none;
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${inset(0, spacing.base * 8)};

      &:first-child {
        padding: ${stack(spacing.base * 8)};
      }
    `,
  )};
`;

export const filterHeading = css`
  text-transform: capitalize;
  margin: ${stack(spacing.lg)};
  display: flex;
  align-items: center;
`;

export const filterCount = css`
  margin-left: ${pxToRem(spacing.sm)};
`;
